import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/Home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      component: () => import('@/views/login/login'),
      hidden: true
    },
    {
      path: '/main/forgetpsd',
      hidden: true,
      name: '忘记密码',
      component: () => import('@/views/forgetpsd/ForgetPsd')
    },{
      path: '/main/sendemail',
      hidden: true,
      name: '发送邮件',
      component: () => import('@/views/forgetpsd/SendEmail')
    },{
      path: '/main/resetPsd',
      hidden: true,
      name: '重置密码',
      component: () => import('@/views/forgetpsd/ResetPsd')
    },{
      path: '/main/success',
      hidden: true,
      name: '重置成功',
      component: () => import('@/views/forgetpsd/success')
    },
    // 密码管理
    {
      path: '/',
      name: '管理配置',
      component: Home,
      children: [
        {
          path: '/',
          redirect: '/main/list'
        },
        {
          path: '/main/appManagement',
          hidden: true,
          name: '应用管理',
          component: () => import('@/views/appManagement/index.vue')
        },
        {
          path: '/main/list',
          hidden: true,
          name: '用户列表',
          component: () => import('@/views/user/UserList')
        },{
          path: '/main/pageSet',
          hidden: true,
          name: '页面配置',
          component: () => import('@/views/pageSet/index')
        }
      ]
    }
    // 404 page must be placed at the end !!!
    // {
    //   path: '*',
    //   redirect: '/404',
    //   hidden: true
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js